export default __webpack_public_path__ + "static/media/this-is-your-home-1.ccd427f2.webp";